import styled from "styled-components";

export const LoginContainer = styled.div``;

export const LoginContainerWrapper = styled.div``;

export const LoginMainWrap = styled.main`
  margin-top: 12.2rem;
  .inner {
    display: flex;
    gap: 23rem;
    max-width: 152rem;
    margin: 0 auto;
    .login-form {
      width: 40rem;
      margin-left: 8.5rem;
      h3 {
        text-align: left;
        font-size: 3.2rem;
        color: #2d2d2d;
        font-weight: bold;
        margin-bottom: 2rem;
      }
      .input-wrap {
        border: 1px solid #ebebeb;
        border-radius: 0.6rem;
        margin-bottom: 2rem;
        .input-box {
          position: relative;
          padding: 1.3rem 2rem 1rem;
          height: 6.7rem;
          border-bottom: 1px solid #ebebeb;
          display: flex;
          align-items: end;
          &:last-child {
            border-bottom: 0;
          }
          label {
            position: absolute;
            color: #9a9a9a;
            font-size: 1.2rem;
            letter-spacing: -0.05rem;
            top: 1.3rem;
          }
          span {
            display: flex;
            position: absolute;
            bottom: -1px;
            left: 50%;
            background-color: #30a690;
            width: 0;
            height: 2px;
            border-radius: 2px;
            transform: translateX(-50%);
            transition: all 0.5s;
          }
          input:focus ~ span {
            width: 100%;
          }
          input[type="text"],
          input[type="password"] {
            width: 100%;
            border: none;
            font-size: 2rem;
            padding: 0;
            background-color: transparent;
          }
        }
      }
      .submit-btn-box {
        input[type="submit"] {
          width: 100%;
          border: 0;
          outline: none;
          background-color: #30a690;
          color: white;
          box-shadow: 4px 4px 16px 0 #30a69066;
          padding: 1.8rem;
          border-radius: 0.6rem;
          font-size: 2rem;
          margin-bottom: 1.8rem;
        }
        span {
          font-size: 1.6rem;
          text-align: center;
          width: 100%;
          display: block;
          color: #9a9a9a;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .sub-fn {
        display: flex;
        gap: 2rem;
        align-items: flex-start;
        margin-bottom: 2rem;
        flex-direction: column;
        .save-fn {
          display: flex;
          align-items: center;
          gap: 0.4rem;
          input[type="checkbox"] {
            width: 2.4rem;
            height: 2.4rem;
          }
          label {
            font-size: 1.6rem;
          }
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    margin-top: 5rem;
    .inner {
      .login-form {
        width: 100%;
        margin: 0;
        padding: 0 2rem;
        h3 {
        }
        .input-wrap {
          .input-box {
            &:last-child {
            }
            label {
            }
            span {
            }
            input:focus ~ span {
            }
            input[type="text"],
            input[type="password"] {
            }
          }
        }
        .submit-btn-box {
          input[type="submit"] {
          }
          span {
          }
        }
        .sub-fn {
          flex-direction: column;
          .save-fn {
            input[type="checkbox"] {
            }
            label {
            }
          }
        }
      }
    }
    .bg {
      display: none;
    }
  }
`;

export const ErrorTxt = styled.div`
  position: absolute;
  z-index: -1;
  bottom: 1.1rem;
  color: #ed2115;
  font-size: 1.6rem;
`;
